exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.flip-list-move {\n  transition: transform 0.5s;\n}\n.no-move {\n  transition: transform 0s;\n}\n.ghost {\n  opacity: 0.5;\n  background: #e2edfb;\n}\n.list-group {\n  min-height: 20px;\n}\n.list-group.must-have li {\n    background: #e2e2e2;\n}\n.list-group.must-have li:last-child {\n    border-bottom: 0px;\n}\n.list-group-item {\n  cursor: move;\n}\n.list-group-item i {\n  cursor: pointer;\n}\n", ""]);

// exports
